export default {"src":"/pages/_next/static/media/top100-highest-satisfaction.fc18efd0.svg","height":124,"width":110,"blurWidth":0,"blurHeight":0};